// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input::placeholder {
  font-weight: 100;
}

input[type=date],
input[type=time],
input[type=text]:focus {
  font-weight: 100;
}

.input-custom {
  border: 1px solid #d1d1d1ce;
  background-color: #ffffff;
}

.input-custom:hover {
  background-color: transparent !important;
  color: inherit !important;
}

.location-input:disabled {
  background-color: transparent !important;
}

.location-input {
  border-color: #d3d3d3;
  border-left: none;
}

.interview-sched-div {
  border-left: 1px solid #d3d3d3;
  height: 100%;
  width: 3px;
}

.interview-sched-wrapper {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
}

.interview-sched-col-1 {
  width: 60%;
}

.interview-sched-col-2 {
  display: flex;
  justify-content: center;
}

.interview-sched-col-3 {
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 15px;
}

.input-group-text-interview {
  background-color: #fff;
  border-color: #d3d3d3;
  border-right: 0;
}

.date-time-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 10px;
  justify-content: start;
  width: 100%;
  column-gap: 8px;
}

.date-time-row-from,
.date-time-row-to {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
}

.location-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 10px;
  justify-content: start;
  width: 100%;
  column-gap: 8px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./../interview/src/components/OffCanvasComponents/InterviewScheduler.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;;;EAGE,gBAAA;AACF;;AAEA;EACE,2BAAA;EACA,yBAAA;AACF;;AAEA;EACE,wCAAA;EACA,yBAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAGA;EACE,sBAAA;EACA,qBAAA;EACA,eAAA;AAAF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AADF;;AAIA;;EAEE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AADF","sourcesContent":["input::placeholder {\n  font-weight: 100;\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"text\"]:focus {\n  font-weight: 100;\n}\n\n.input-custom {\n  border: 1px solid #d1d1d1ce;\n  background-color: #ffffff;\n}\n\n.input-custom:hover {\n  background-color: transparent !important;\n  color: inherit !important;\n}\n\n.location-input:disabled {\n  background-color: transparent !important;\n}\n\n.location-input {\n  border-color: #d3d3d3;\n  border-left: none;\n}\n\n.interview-sched-div {\n  border-left: 1px solid #d3d3d3;\n  height: 100%;\n  width: 3px;\n}\n\n.interview-sched-wrapper {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.interview-sched-col-1 {\n  width: 60%;\n}\n\n.interview-sched-col-2 {\n  display: flex;\n  justify-content: center;\n}\n\n.interview-sched-col-3 {\n  width: 35%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 15px;\n  // justify-content: space-between;\n}\n\n.input-group-text-interview {\n  background-color: #fff;\n  border-color: #d3d3d3;\n  border-right: 0;\n  // padding-right: 0;\n}\n\n.date-time-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  justify-content: start;\n  width: 100%;\n  column-gap: 8px;\n}\n\n.date-time-row-from,\n.date-time-row-to {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  column-gap: 8px;\n}\n\n.location-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  justify-content: start;\n  width: 100%;\n  column-gap: 8px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
